import { Grid, Typography } from '@mui/material';
import { DaysDropdown } from './drop-down';

export const ReportDaySelection = ({
  chosen,
  setChosen,
  openDateModalHandler,
  items
}) => {
  return (
    <Grid
      container
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        pt: '40px',
        px: { md: '64px' }
      }}
    >
      <Grid item>
        <DaysDropdown
          items={items}
          chosen={chosen}
          setChosen={setChosen}
          openDateModalHandler={openDateModalHandler}
        />
      </Grid>
      <Grid item>
        <Typography
          sx={{
            fontFamily: 'dana-bold',
            fontSize: { xs: '10px', md: '20px' },
            textTransform: 'uppercase',
            color: { xs: '#707070', md: '#4D4D4E' }
          }}
        >
          :VIEW REPORT
        </Typography>
      </Grid>
    </Grid>
  );
};
